import { useTranslation } from 'react-i18next';

import { Document } from 'api/objectDocs/type';

interface DocumentCellProps {
  data: Document;
}

const DocumentCell: React.FC<DocumentCellProps> = ({ data }) => {
  const { t } = useTranslation();
  let iconClassName;
  let bgClassName;
  let textClassName;

  switch (data.file_type) {
    case 'PDF':
      iconClassName = 'ri-file-pdf-fill';
      bgClassName = 'bg-danger-subtle';
      textClassName = 'text-danger';
      break;
    case 'XLS':
      iconClassName = 'ri-file-excel-fill';
      bgClassName = 'bg-success-subtle';
      textClassName = 'text-success';
      break;
    default:
      iconClassName = 'ri-folder-line';
      bgClassName = 'bg-info-subtle';
      textClassName = 'text-info';
  }

  return (
    <div className="d-flex align-items-center">
      <div className="avatar-sm">
        <div className={`avatar-title ${bgClassName} ${textClassName} rounded fs-20`}>
          <i className={iconClassName} />
        </div>
      </div>
      <div className="ms-3 flex-grow-1">
        <h6 className="fs-15 mb-0">
          {data.file ? (
            <a href={data.file} target="_blank" rel="noreferrer">
              {data.doc_name}
            </a>
          ) : (
            <span className="text-danger">{t('ObjectDocs.doc-cell.warning')}</span>
          )}
        </h6>
      </div>
    </div>
  );
};

export default DocumentCell;
